import './App.css'
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Home from './pages/homepage'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import UserAgent from './pages/test/user-agent'

import { onMessageListener } from "./firebase/messaging.js"
import { useEffect } from 'react'

function App() {

  useEffect(() => {
    const sw = navigator.serviceWorker

    onMessageListener()
      .then(payload => {
        if (sw) {
          sw.controller.postMessage({ type: 'showNotif', ...payload.data })
        }
      })
      .catch((err) => console.error("Error:", err))


  }, [])

  return (
    <div className="App">
      <>
        <Router>
          <Routes>
            <Route path="/" exact element={<Home />}></Route>
            <Route path="/test/user-agent" exact element={<UserAgent />}></Route>
          </Routes>
        </Router>
      </>
      <ToastContainer />
    </div>
  )
}

export default App
